import React, { useEffect, useRef } from 'react';
import { loadModules } from 'esri-loader';
import { makeStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faHome, faPlus, faMinus, faCloudUploadAlt, faInfoCircle, faExclamationCircle, faCheck, faFlag } from '@fortawesome/free-solid-svg-icons';
import { faObjectGroup } from '@fortawesome/free-regular-svg-icons';
import Button from '@material-ui/core/Button';
import Home from '../Home';
import LocationSearchingIcon from '@material-ui/icons/LocationSearching';
import { Box, CircularProgress } from '@material-ui/core';
import LayersIcon from '@material-ui/icons/Layers';
import FilterListIcon from '@material-ui/icons/FilterList';
import Paper from '@material-ui/core/Paper';
import Collapse from '@material-ui/core/Collapse';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import ErrorMessage from '../AppLayouts/ErrorMessage';
import Cookies from 'js-cookie';
import { setCookie, clearCookie, getPrivileges } from '../../functions/Auth';
import MidBlock from '../DataFilter/MidBlock';
import Intersection from '../DataFilter/Intersection';
import ExportData from '../DataFilter/ExportData';
import API_PATH from "../../constants/config.json";
import SearchResults from '../DataFilter/SearchResults';
import { NavLink, useHistory } from 'react-router-dom';
import ImportPanel from './ImportData/ImportPanel';
import ImportList from './ImportData/ImportList';
import DICTIONARY_TO_SEARCH from "../../constants/dictionary.json";
import ExternalLayers from './ExternalLayers';

import PopupTemplate from '../DataFilter/PopupTemplate';
import { Close } from '@material-ui/icons';
import ExportExternalLayers from './ExportExternalLayers';
              
              
let flag=false;
const axios = require('axios');
const queryString = require('query-string');
const API_URL = process.env.REACT_APP_BASE_URL;
let geolayer;
let sp = true; // search panel status
let geojsonLayer = null;
let changeBasemap = false;
let importDataMapPoint = false;
let myIndexValue = null;
let map;
let homeButton;
let sidebarWidth = '300px';
let cLayers = [];
let featureLayerView;
let filterLayerView;
let featurExternalLayerView = [];

const AWS = require('aws-sdk');
export const MapContext = React.createContext();

//Start Css Code ...
const useStyles = makeStyles((theme) => ({
  mainMapContainer: {
    '& .esri-basemap-toggle': {
      bottom: '6%',
      right: '9%',
      position: 'fixed !important'
    }
  },
  layerExternalButton: {
    position: 'absolute',
    top: '65px',
    left: '25px',
    '& button': {
      color: '#24618E',
      backgroundColor: '#fff',
      border: '1px solid #24618E',
      padding: '5px',
      minWidth: 'auto',
      fontSize: '34px',
      '&:hover': {
        color: '#fff',
        backgroundColor: '#24618E'
      }
    }
  },
  popUp: {
    top: '20%',
    width: '100%'
  },
  showBtn: {
    color: '#24618E',
    border: '1px solid #24618E',
    fontSize: '12px',
    background: '#fff !important',
    padding: '5px',
    '@media only screen and (max-width: 3500px)': {
      height: '38px',
      minWidth: '40px !important',
    },
    '@media only screen and (min-width: 3501px)': {
      height: '57px',
      minWidth: '60px !important',
    },
  },
  hideBtn: {   
    fontSize: '12px',
    background: '#24618E !important',
    padding: '5px',
    '@media only screen and (max-width: 3500px)': {
      height: '38px',
      minWidth: '40px !important',
    },
    '@media only screen and (min-width: 3501px)': {
      height: '57px',
      minWidth: '60px !important',
    },
  },
  mainpop: {
    marginTop: '10px',
  },
  inputSearch: {
    '& .MuiOutlinedInput-root': {
      height: '36px'
    },
    '& .MuiFormControl-marginNormal': {
      marginTop: 0,
    },
    display: 'flex',
    position: 'relative',
    float: 'none',
    margin: '0 auto',
    '@media only screen and (max-width: 3500px)': {
      width: '695px',
      left: '0px',
      height: '37px',
    },
    '@media only screen and (min-width: 3501px)': {
      width: '1200px',
      left: '0px',
      height: '57px',
    },
  },
  layerButton: {
    display: 'flex'
  },
  textField: {
    display: 'flex',
    backgroundColor: '#fff',
    marginLeft: '10px',
    width: '80%',
    '& fieldset': {
      border: '1px solid #24618E !important',
      height: '43px',
    },
    '& .esri-search': {
      width: '100%'
    },
    '& .esri-search__submit-button': {
      position: 'relative',
      width: '40px',      
      color: ' #fff',
      border: '1px solid #24618E',
      fontSize: '20px',
      background: '#24618E',
      textAlign: 'center',
      padding: '5px',
      borderRadius: '0px 5px 5px 0px',
      cursor: 'pointer',
      height: '38px',
    },
    '& .esri-search__input': {
      '@media only screen and (min-width: 3501px)': {
        fontSize: '22pt !important'
      },
    },
    '& .esri-input[type="text"]': {
      '@media only screen and (max-width: 3500px)': {
        height: '35px'
      },
      '@media only screen and (min-width: 3501px)': {
        height: '55px',
        fontSize: '22pt !important'
      },
    },
    '& .esri-search__suggestions-menu': {
      width: '93%',
      top: '94% !important',
      border: '1px solid #24618E'
    },
    '& .esri-menu__list-item': {
      borderTop: 'none'
    },
    '& .esri-icon-search': {
      fontWeight: '900',
      fontSize: '20px',
      color: '#fff !important'
    },
    '& .esri-search__submit-button.esri-widget--button': {
      background: ' #24618E !important',
      color: '#fff !important'
    },
    '& .esri-search__form': {
      border: '1px solid #24618E',
      borderRadius: '0px',      
      borderBottomRightRadius: '0px',
      borderRight: 0,
      borderLeft: 0,
    },
    '& .esri-menu__list-item:hover': {
      backgroundColor: '#24618E',
      color: '#fff'
    },
    '& .esri-search__clear-button': {
      color: '#24618E',
      marginTop: '0px',
      height: '38px',
      border: '1px solid #24618E',
      borderLeft: '0px',
    },
    '& .esri-icon-close': {
      fontWeight: 'bold',
      fontSize: '13px'
    },
    '& .esri-search__sources-button': {
      height: '38px',
      border: '1px solid #24618E',
      borderRadius: ' 5px 0px 0px 5px',
      width: '38px'
    },
    '& .esri-icon-down-arrow:before': {    
    }
  },
  fieldIcons: {
    display: 'flex',
    marginLeft: '-1%'
  },
  station: {
    position: 'relative',
    width: '40px',
    color: '#24618E',
    border: '1px solid #24618E',
    fontSize: '20px',
    background: '#fff',
    textAlign: 'center',
    padding: '5px',
    borderRadius: '0px 5px 5px 0px',
    cursor: 'pointer',
    height: '38px',
  },
  ruler: {
    position: 'relative',
    width: '40px',
    color: '#24618E',
    border: ' 1px solid #24618E',
    fontSize: '20px',
    background: '#fff',
    textAlign: 'center',
    padding: '5px',
    borderRadius: '5px',
    height: '35px',
    marginLeft: '10px',
    cursor: 'pointer',
    height: '38px',
  },
  polygon: {
    position: 'relative',
    color: '#24618E',
    border: '1px solid #24618E',
    background: '#fff',
    textAlign: 'center',
    padding: '6px 5px',
    borderRadius: '5px 5px 5px 5px',
    marginLeft: '15px',
    cursor: 'pointer',
    zIndex: '1',
    '@media only screen and (max-width: 3500px)': {
      width: '40px',
      height: '38px',
      fontSize: '20px',
    },
    '@media only screen and (min-width: 3501px)': {
      width: '60px',
      height: '58px',
      fontSize: '37px',
    },
  },
  hidePolygon: {
    position: 'relative',
    color: '#fff',
    border: '1px solid #24618E',
    background: '#24618E',
    textAlign: 'center',
    padding: '6px 5px',
    borderRadius: '5px 5px 5px 5px',
    marginLeft: '15px',
    cursor: 'pointer',
    zIndex: '1',
    '@media only screen and (max-width: 3500px)': {
      width: '40px',
      height: '38px',
      fontSize: '20px',
    },
    '@media only screen and (min-width: 3501px)': {
      width: '60px',
      height: '58px',
      fontSize: '37px',
    },
  },
  hidePolygon: {
    position: 'relative',
    width: '40px',
    color: '#fff',
    border: '1px solid #24618E',
    fontSize: '20px',
    background: '#24618E',
    textAlign: 'center',
    padding: '6px 5px',
    borderRadius: '5px 5px 5px 5px',
    marginLeft: '15px',
    cursor: 'pointer',
    height: '38px',
    zIndex: '1',
  },
  inIcon: {
    position: 'relative',
    color: '#24618E',
    border: '1px solid #24618E',
    background: '#fff',
    textAlign: 'center',
    padding: '5px',
    marginBottom: '10px',
    cursor: 'pointer',
    borderRadius: '0px 0px 5px 5px',
    zIndex: '1',
    '@media only screen and (max-width: 3500px)': {
      width: '40px',
      fontSize: '20px',

    },
    '@media only screen and (min-width: 3501px)': {
      width: '60px',
      height: '60px !important',
      fontSize: '35px',

    },
  },
  mainpopup: {
    background: '#fff',
    position: 'relative',
    margin: '10px auto 0',
    border: '1px solid #24618E',
    borderRadius: '5px',
    left: '10px',
    '@media only screen and (max-width: 3500px)': {
      width: '690px',
    },
    '@media only screen and (min-width: 3501px)': {
      width: '1200px',
    },
  },
  popupoverlap: {
    position: 'relative', margin: '0 auto',
    '@media only screen and (max-width: 3500px)': {
      width: '700px',
      paddingTop: '65px'
    },
    '@media only screen and (min-width: 3501px)': {
      width: '1210px',
      paddingTop: '100px'
    },
  },
  homePopBox: {
    margin: '0 auto',
    marginTop: '5px',
    '& .MuiCollapse-wrapper': {
      marginLeft: '-25px',
    }
  },
  errMsgLogin: {
    '& span': {
      fontSize: '11pt !important'
    }
  },
  searchLoader: {
    width: '100%',
    float: 'left',
    '& .MuiCircularProgress-root': {
      width: '30px !important',
      height: '30px !important',
      position: 'relative',
      top: '3px',
      left: '46%',
      color: '#24618E',
    }
  },
  root: {
    '& > *': {
      margin: theme.spacing(1),
      width: '98%',
    },
  },
  rootBox: {
    flexGrow: 1,
  },
  paper: {
    width: '100%',
    boxShadow: 'none',
    display: 'flex',
    margin: '0px',
  },
  popUp: {
    top: '20%',
    width: '100%'
  },
  btnIcon: {
    '@media only screen and (max-width: 3500px)': {
      fontSize: '20px',
    },
    '@media only screen and (min-width: 3501px)': {
      fontSize: '40px',
    },
  },
  mainpop: {
    marginTop: '10px',
  },
  layerButton: {
    display: 'flex'
  },
  textField: {
    display: 'flex',    
    marginLeft: '10px',
    borderRadius: '5px',
    '@media only screen and (max-width: 3500px)': {
      width: '90%',
    },
    '@media only screen and (min-width: 3501px)': {
      width: '88.5%',
      marginRight: '0.5%',
    },
    '& fieldset': {
      border: '1px solid #24618E !important',
      height: '43px',
    },
    '& .esri-search': {
      width: '100%',
      borderRadius: '5px',
    },
    '& .esri-search__submit-button': {
      position: 'relative',     
      color: ' #fff',
      border: '1px solid #24618E',
      fontSize: '20px',
      background: '#24618E',
      textAlign: 'center',
      padding: '5px',
      borderRadius: '0px 5px 5px 0px',
      cursor: 'pointer',
      '@media only screen and (max-width: 3500px)': {
        height: '38px',
        width: '40px',
      },
      '@media only screen and (min-width: 3501px)': {
        height: '57px',
        width: '60px',
      },
    },
    '& .esri-input[type="text"]': {
      '@media only screen and (max-width: 3500px)': {
        height: '35px',
        fontSize: '12pt !important'
      },
      '@media only screen and (min-width: 3501px)': {
        height: '55px',
        fontSize: '22pt !important'
      },
    },
    '& .esri-search__suggestions-menu': {
      width: '93%',
      top: '94% !important',
      border: '1px solid #24618E'
    },
    '& .esri-menu__list-item': {
      borderTop: 'none'
    },
    '& .esri-icon-search': {
      fontWeight: '900',
      color: '#fff !important',
      '@media only screen and (max-width: 3500px)': {
        fontSize: '20px',
      },
      '@media only screen and (min-width: 3501px)': {
        fontSize: '35px',
      },
    },
    '& .esri-search__submit-button.esri-widget--button': {
      background: ' #24618E !important',
      color: '#fff !important'
    },
    '& .esri-search__form': {
      border: '1px solid #24618E',
      borderRadius: '0px',     
      borderBottomRightRadius: '0px',
      borderRight: 0,
      borderLeft: 0,
    },
    '& .esri-menu__list-item:hover': {
      backgroundColor: '#24618E',
      color: '#fff'
    },
    '& .esri-search__clear-button': {
      color: '#24618E',
      marginTop: '0px',
      border: '1px solid #24618E',
      borderLeft: '0px',
      '@media only screen and (max-width: 3500px)': {
        height: '38px'
      },
      '@media only screen and (min-width: 3501px)': {
        height: '57px'
      },
    },
    '& .esri-icon-close': {
      fontWeight: 'bold',
      fontSize: '13px'
    },
    '& .esri-search__sources-button': {
      border: '1px solid #24618E',
      borderRadius: ' 5px 0px 0px 5px',
      '@media only screen and (max-width: 3500px)': {
        height: '38px',
        width: '38px',
      },
      '@media only screen and (min-width: 3501px)': {
        height: '57px',
        width: '57px',
      },
    },
    '& .esri-icon-down-arrow:before': {      
    }
  },
  fieldIcons: {
    display: 'flex',
    marginLeft: '-1%'
  },
  station: {
    position: 'relative',
    width: '40px',  
    color: '#24618E',
    border: '1px solid #24618E',
    fontSize: '20px',
    background: '#fff',
    textAlign: 'center',
    padding: '5px',
    borderRadius: '0px 5px 5px 0px',
    cursor: 'pointer',
    height: '38px',
  },
  ruler: {
    position: 'relative',
    width: '40px',    
    color: '#24618E',
    border: ' 1px solid #24618E',
    fontSize: '20px',
    background: '#fff',
    textAlign: 'center',
    padding: '5px',
    borderRadius: '5px',
    height: '35px',
    marginLeft: '10px',
    cursor: 'pointer',
    height: '38px',
  },
  homeIcon: {
    position: 'relative',
    color: '#24618E',
    border: '1px solid #24618E',
    background: '#fff',
    textAlign: 'center',
    padding: '5px',
    marginBottom: '10px',
    cursor: 'pointer',
    borderRadius: '5px',
    zIndex: '1',
    '@media only screen and (max-width: 3500px)': {
      width: '40px',
      fontSize: '20px',

    },
    '@media only screen and (min-width: 3501px)': {
      width: '60px',
      height: '60px !important',
      fontSize: '35px',

    },
  },
  locationIcon: {
    position: 'relative',
    color: '#24618E',
    border: '1px solid #24618E',
    background: '#fff',
    textAlign: 'center',
    padding: '4px 5px 0px 5px',
    marginBottom: '10px',
    cursor: 'pointer',
    borderRadius: '5px',
    zIndex: '1',
    '@media only screen and (max-width: 3500px)': {
      width: '40px',
      fontSize: '20px',

    },
    '@media only screen and (min-width: 3501px)': {
      width: '60px',
      height: '60px !important',
      fontSize: '35px',

    },
    '& svg': {
      '@media only screen and (max-width: 3500px)': {
        fontSize: '20px',

      },
      '@media only screen and (min-width: 3501px)': {
        fontSize: '40px',
      },
    }
  },
  zoomIcon: {
    position: 'relative',
    color: '#24618E',
    border: '1px solid #24618E',
    background: '#fff',
    textAlign: 'center',
    padding: '5px',
    marginBottom: '10px',
    cursor: 'pointer',
    borderRadius: '5px 5px 0px 0px',
    zIndex: '1',
    '@media only screen and (max-width: 3500px)': {
      width: '40px',
      fontSize: '20px',

    },
    '@media only screen and (min-width: 3501px)': {
      width: '60px',
      height: '60px !important',
      fontSize: '35px',
    },
  },
  errMsgLogin: {
    '& span': {
      fontSize: '11pt !important'
    }
  },
  exportDataPanel: {
    width: '100%',
    float: 'left',
  },
  crossIcon: {
    color: '#24618d',
    fontSize: '20pt',
    fontFamily: 'Avenir_Black',
    fontWeight: '800',
    position: 'absolute',
    width: '40px !important',
    right: '5px',
    "&:hover": {     
      cursor: 'pointer',
    }
  },
  homeIconList: {
    position: 'absolute', width: 'max-content',
    bottom: '5%',
    '@media only screen and (max-width: 3500px)': {
      right: '5%',
    },
    '@media only screen and (min-width: 3501px)': {
      right: '2%',
    },
  },
  inactiveSourcesPanel: {
    '& .esri-search__sources-menu': {
      visibility: 'hidden !important'
    }
  }
}))
//End Css Code ...

let myGeoLayer;
let pointGraphic;
let point;
let stationData;
let stationIDData = [];
let basemapView;
let searchedList = [];
let layerViewUpdated = false;

//Start MapView component code ...
const MapView = (props) => {
  let chekpath = false;
  const classes = useStyles();
  if (window.location.pathname == "/" || window.location.pathname == "/UsersDashboard") {
    chekpath = false;
  }
  const [popupTitle, setPopupTitle] = React.useState("");
  const [popupContent, setPopupContent] = React.useState([]);
  const [popuptemplateChecked, setPopuptemplateChecked] = React.useState(false);
  const [checked, setChecked] = React.useState(chekpath);
  const mapRef = useRef();
  const searchRef = useRef();
  const [basemap, setbasemap] = React.useState('topo-vector');
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [home, setHome] = React.useState(null);
  const [zoom, setZoom] = React.useState(null);
  const [locate, setLocate] = React.useState(null);
  const [measurement, setMeasurement] = React.useState(null);
  const [errPopUp, setErrPopUp] = React.useState(false);
  const [mapLoadStatus, setMapLoadStatus] = React.useState(0);
  const [showAllStations, setShowAllStations] = React.useState(null);
  const [mapView, setMapView] = React.useState(null);
  const [midblockChecked, setMidblockChecked] = React.useState(false);
  const [intersectionChecked, setIntersectionChecked] = React.useState(false);
  const [panelStationData, setPanelStationData] = React.useState();
  const [geoJSONNF, setGeoJSONNF] = React.useState(false);
  const [searchChecked, setSearchChecked] = React.useState(false);
  const [searchResult, setSearchResult] = React.useState([]);
  const [searchParam, setSearchParam] = React.useState('');
  const [selectedStation, setSelectedStation] = React.useState();
  const [selectedStationType, setSelectedStationType] = React.useState();
  const [tempView, setTempView] = React.useState(null);
  const [tempGeoLayer, setTempGeoLayer] = React.useState(null);
  const [myView, setMyView] = React.useState(null);
  const [loaderOff, setLoaderOff] = React.useState(false);
  const [loadSource, setLoadSource] = React.useState(true);
  const [checkedImport, setCheckedImport] = React.useState(false);
  const [showFileList, setShowFileList] = React.useState('none');
  const [details, setDetails] = React.useState([]);
  const [showimportData, setShowimportData] = React.useState('none');
  const [loaderShow, setLoaderShow] = React.useState('block');
  const [mapLocation, setMapLocation] = React.useState([]);
  const [stationDetails, setStationDetails] = React.useState([]);
  const [importResponceValue, setImportResponceValue] = React.useState(0);
  const [showUseStationData, setShowUseStationData] = React.useState('none');
  const [fileCountData, setFileCountData] = React.useState('block');
  const [showImportButton, setShowImportButton] = React.useState('block');
  const [geoLayer, setGeoLayer] = React.useState();
  const [geoLayerData, setGeoLayerData] = React.useState();
  const [allStationList, setAllStationList] = React.useState([]);
  const [exportChecked, setExportChecked] = React.useState('none');
  const [getSearchWidget, setSearchWidget] = React.useState(null);
  const [searchedStation, setSearchedStation] = React.useState(null);
  const [idIndex, setIdIndex] = React.useState(null);
  const [useStationId, setUseStationId] = React.useState();
  const [useStationLocation, setUseStationLocation] = React.useState();
  const [useStationLat, setUseStationLat] = React.useState();
  const [useStationLong, SetUseStationLong] = React.useState();
  const [useStationStatus, SetUseStationStatus] = React.useState();
  const [multipleStationId, setMutipleStationId] = React.useState([]);
  const [singleMidblockStationId, setSingleMidblockStationId] = React.useState([]);
  const [singleIntersectionStationId, setSingleIntersectionStationId] = React.useState([]);
  const [zoomLevel, setZoomLevel] = React.useState(null);

  const [getFileStorage, setFileStorage] = React.useState(0);
  const [getCloudStorage, setCloudStorage] = React.useState(0);

  const [getMapLayer, setMapLayer] = React.useState(true);

  const [polygonActive, setPolygonActive] = React.useState(false);
  const [importStationId, setImportStationId] = React.useState(false);
  const [showSearchUseStationData, setSearchShowUseStationData] = React.useState('none');

  // external layers variables
  let layersFlag = sessionStorage.getItem('layersFlag');
  const [showExternalLayers, setShowExternalLayers] = React.useState(false);
  const [addingExternalLayer, setAddingExternalLayer] = React.useState(false);
  const [layerName, setLayerName] = React.useState("");
  const [layerUrl, setLayerUrl] = React.useState("");
  const [symbolColor, setSymbolColor] = React.useState("");
  const [customLayers, setCustomLayers] = React.useState([]);
  let [myCustomLayers, setMyCustomLayers] = React.useState([]);
  const [externalLayersToExport, setExternalLayersToExport] = React.useState([]);

  const prevLoginRef = React.useRef();
  const prevLogin = prevLoginRef.current;
  let view = null;
  let history = useHistory();

  useEffect(
    () => {
      // Home click resets map code starts
      if (props.clicked && props.clicked.clicked) {        
        if (tempView) {
          tempView.graphics.removeAll();
          // tempView.zoom = 14;
        }       
        setSearchChecked(false);
        sp = true;
        setMidblockChecked(false);
        setPopuptemplateChecked(false);
        setIntersectionChecked(false);
        if (geolayer && mapView) {
          mapView.remove(geolayer);
        }
        if (home) home.go();
        if (getSearchWidget) getSearchWidget.clear();
        setTimeout(() => {
          setChecked(false);
          setMapLayer(true);
        }, 150);
        props.clicked.clicked = false;
        if (geojsonLayer) {
          geojsonLayer.visible = true;
        }
      }
      // Home click resets map code ends

      prevLoginRef.current = props.newLogin;
      if (props.newLogin && props.newLogin !== prevLogin) { //show login success message
        setErrPopUp(true);
        sp = true;
      }
      const parsed = queryString.parse(window.location.search);
      if (parsed && parsed.import == 1 && getPrivileges().length !== 0) { // open import file drag and drop modal
        if (parsed.station) {
          setImportStationId(parsed.station);
          // setMidblockChecked(false);
          // setIntersectionChecked(false);
        } else {
          setMidblockChecked(false);
          setIntersectionChecked(false);
          setImportStationId();
          if (tempView) {
            tempView.graphics.removeAll();
            tempView.zoom = 14;
          }
          // if (geojsonLayer) {
          //   geojsonLayer.visible = false;
          // }
          setSearchChecked(false);
          sp = true;
        }
        setCheckedImport(true);
        getAllStationList();
      } else {
        setCheckedImport(false);
      }
      if (mapLoadStatus === 0) {
        changeBasemap = false;
        geojsonLayer = null;
        if (getPrivileges().length !== 0) {
          getStationId();
        }
        callMap();
      }
    }, [basemap, props.newLogin, showAllStations, window.location.search, props.clicked]
  );


  /** External layers functions **/
  const handleShowLayersContainer = () => {
    setShowExternalLayers(!showExternalLayers);
  }
  const handleAddLayer = () => {
    setAddingExternalLayer(!addingExternalLayer);
  }

  const getExternalLayers = async() => {
    try {
      axios({
          method: 'post',
          headers: {
              'payload': Cookies.get('payload'),
              'agencyid': sessionStorage.getItem('agency_id')
          },
          url: API_URL + API_PATH.getLayers,
      })
      .then(async function (response) {
          if (response.status && response.status == '200') {
              let data = response.data.data;
              let tmpExternal = [];
              data.forEach( function(layer, ind) {
                loadModules(["esri/layers/FeatureLayer"], { css: true })
                .then(async ([FeatureLayer]) => {

                  const template=layer.json_template

                  let tmpLayer = new FeatureLayer({
                    url: layer.url,
                    popupTemplate:template,
                    layer_type_a:"external"
                  });
                  
                  if(layer.json_style) {
                    tmpLayer.renderer = layer.json_style;
                  }
                  map.add(tmpLayer, ind);
                  let visibleV = layer.visibility;
                  // gettins external layers from cookies just for logged users
                  if(Cookies.get('payload') && Cookies.get('externalLayers') && Cookies.get('externalLayers') !== ""){
                    let cookiesLayers = JSON.parse(Cookies.get('externalLayers'));
                    cookiesLayers.forEach(function(cookieL){
                      if(cookieL.layerName === layer.name){
                        visibleV = cookieL.visible;
                        tmpLayer.visible = cookieL.visible;
                      }
                    })
                  } else {
                    tmpLayer.visible = visibleV;
                  }
                  tmpExternal.splice(layer.order,0,{layerName: layer.name, layerUrl: layer.url, layerType: layer.type, layerObj: tmpLayer, visible: visibleV, order: layer.order });
                });
              });
              setCustomLayers(tmpExternal)
              map.add(geojsonLayer);
              polygonValidation();
              cLayers = tmpExternal;
          } 
      })
    } catch (error) {
        console.error(error);
    }
  }

  const polygonValidation = () => {
    if(Cookies.get('payload') && Cookies.get('polygonExtent')) {
      let extent = JSON.parse(Cookies.get('polygonExtent'));
      view.whenLayerView(geojsonLayer).then(function(layerView){
        layerView.watch("updating", function(val){
          if(!val && !layerViewUpdated){  // wait for the layer view to finish updating
            layerView.queryExtent().then(function(results){
              view.extent = extent;  // go to the extent of all the graphics in the layer view
            });
            layerViewUpdated = true;
            clearCookie('polygonExtent');
          }
        });
      });
    }
  }

  const handleSaveLayer = (layer) => {
    loadModules(["esri/layers/FeatureLayer"], { css: true })
      .then(async ([FeatureLayer]) => {
        let tmpLayer = new FeatureLayer({
          url: layer.url
        });

        // if(layer.json_style) {
        //   tmpLayer.renderer = layer.json_style
        // }
        map.add(tmpLayer);
        let tmpobj = [...myCustomLayers];
        tmpobj.push(tmpLayer);
        setMyCustomLayers(tmpobj);
      });
  } 

  const handleLayerVisibility = (e, ind) => {
    let visible = e.target.checked;
    customLayers[ind].layerObj.visible = visible;
    let n = customLayers.map( (layer,ii) => {
      if(ii === ind)
        layer.visible = visible;
      return layer;
    })
    setCustomLayers(n);
  }

  const handleReorderLayer = (tmp) => {
    tmp.forEach( layer=> {
      map.remove(layer);
    })
    tmp.forEach( layer=> {
      map.add(layer);
    })
  }
  /****/

  const loaderFunction = () => {
    setLoaderOff(true);
  }

  //This function call all locations    
  const callLocations = (index, filename) => {
    importDataMapPoint =true;
    tempView.graphics.removeAll();
    callAllMapLocations();
    myIndexValue = index;
  }

  //This method is use for use this sation button for station selection on greed .... start 
  const useThisStationDataStation = () => {
    try {
      let items = stationDetails;
      let data;
      let ssId;
      let i = idIndex;
      let newArr = [...details];
      if (idIndex !== null) {
        data = items.filter(item => item.stationId === useStationId);
        ssId = data[0].station_id;
        newArr[i] = {
          uniqueID: details[i].uniqueID,
          station_id: ssId,
          status: 'Queued',
          fileName: details[i].fileName,
          sationId: useStationId,
          dataType: details[i].dataType,
          vendor: details[i].vendor,
          file_status: 'success',
          file_type_id: details[i].file_type_id,
          file_body: details[i].file_body,
          file_exe: details[i].file_exe,
          file_size_status: details[i].file_size_status,
          import_Status: 'ready',
          file_status_id: details[i].file_status_id
        };
        setDetails(newArr);
        setShowimportData('block');
        setShowUseStationData('none');
        setFileCountData('block');
        setShowImportButton('block');
        removeAllMapLocations();
        afterLocationSelect(newArr);
      }
    } catch (error) {
      console.log(error);
    }
  }
  //This method is use for use this sation button for station selection on greed .... end 

  //This method is use for mapview and handle all map event .... Start
  const callMap = (basemap = 'topo-vector',previusBaseMap = 'hybrid') => {
    setMapLoadStatus(1);
    // lazy load the required ArcGIS API for JavaScript modules and CSS
    loadModules(["esri/Map", "esri/views/MapView", "esri/widgets/Locate", "esri/widgets/Home",
      "esri/widgets/Zoom", "esri/widgets/Search","esri/widgets/Search/SearchSource", "esri/widgets/Measurement",
      "esri/layers/FeatureLayer", "esri/Viewpoint", "esri/geometry/Point", "esri/Graphic",
      "esri/layers/GeoJSONLayer", "esri/widgets/Sketch/SketchViewModel", "esri/layers/GraphicsLayer","esri/tasks/support/Query",
      "esri/widgets/BasemapToggle"], { css: true })
      .then(async ([ArcGISMap, MapView, Locate, Home, Zoom, Search,SearchSource, Measurement, FeatureLayer,
        Viewpoint, Point, Graphic, GeoJSONLayer, SketchViewModel, GraphicsLayer,Query,
        BasemapToggle]) => {
        map = new ArcGISMap({
          basemap: basemap,
          slider: false
        });

        view = new MapView({
          container: mapRef.current,
          map: map,
          zoom: 4,
          ui: {
            components: ['home', 'locate'] // specify only the components you want
          }
        });
        var basemapToggle = new BasemapToggle({
          view: view,  // The view that provides access to the map's "streets-vector" basemap
          nextBasemap: previusBaseMap,  // Allows for toggling to the "hybrid" basemap
          container: document.getElementById("basemapToggle")
        });
  
        view.ui.add(basemapToggle);
        setMapView(map);

        
        let featureLayer = new FeatureLayer({
          url: sessionStorage.getItem('mapURL')
        });

        let locate = new Locate({
          view: view,
        });

        homeButton = new Home({
          view: view,
        });

        if (tempView && zoomLevel == true) {
          view.extent = tempView.extent;
        }

        let zoom = new Zoom({
          view: view,
        });

        view.on("mouse-wheel", function (event) {
          setZoomLevel(true);
        });

        basemapView = view;
        setTempView(view);
        let sketchViewModel;
        let polygonGraphicsLayer = new GraphicsLayer();

        // add the select by polygon button the view
        // view.ui.add("select-by-polygon", "top-left");
        const selectButton = document.getElementById("select-by-polygon");
        let polygonToggle = false;

        // click event for the button
        selectButton.addEventListener("click", function () {
          // clearUpSelection();
          if (polygonToggle == false) {
            polygonToggle = true;
          } else {
            polygonToggle = false;
          }
          view.popup.close();
          // ready to draw a polygon
          setPolygonActive(polygonToggle);
          setExternalLayersToExport([]);
          // clear effect to selected layers
          clearFilterExternalLayers();
          clearFilterStations();
          /**/
          if (polygonToggle == true) {
            view.graphics.removeAll();
            // view.zoom = 14;
            setSearchChecked(false);
            setMidblockChecked(false);
            setIntersectionChecked(false);
            document.getElementById("map_block").style.cursor = "crosshair";
            map.add(polygonGraphicsLayer);
            sketchViewModel.create("polygon");
          } else {
            document.getElementById("map_block").style.cursor = "default";
            map.remove(polygonGraphicsLayer);
          }
        });

        // create a new sketch view model set its layer
        sketchViewModel = new SketchViewModel({
          view: view,
          layer: polygonGraphicsLayer,
          pointSymbol: {
            type: "simple-marker",
            color: [255, 255, 255, 0],
            size: "1px",
            outline: {
              color: "gray",
              width: 0
            }
          }
        });

        sketchViewModel.on("create", function (event) {
          if (event.state === "complete") {
            // this polygon will be used to query features that intersect it
            setSearchParam('');
            polygonGraphicsLayer.remove(event.graphic);
            selectFeatures(event.graphic.geometry, view);
            polygonToggle = false;
            setPolygonActive(false);
          } else if ((event.state === "start" || event.state === "active") && polygonToggle == false) {
            sketchViewModel.cancel();
            polygonGraphicsLayer.remove(event.graphic);
          }
        });

        let searchWidget;
        if (getSearchWidget == null) { // initialize search widget

          searchWidget = new Search({ //arcGIS search API to filter data from geoJSON loaded for stations
            allPlaceholder: "Search",
            view: view,
            includeDefaultSources: false,
            locationEnabled: false,
            popupEnabled: false,
            autoSelect: false,
            minSuggestCharacters: 3
          });

          setSearchWidget(searchWidget);

          searchWidget.on("suggest-start", function (event) {
            setSelectedStation(null)
            setMapLayer(true);
            //geojsonLayer.visible = false;
            setMidblockChecked(false);
            setIntersectionChecked(false);
            setChecked(false);
          })

          searchWidget.on("search-start", function (event) {
            setMapLayer(true);
            setMidblockChecked(false);
            setIntersectionChecked(false);
            setChecked(false);
          })

          searchWidget.on("search-complete", function (event) {
            if (geolayer) {
              map.remove(geolayer);
              geolayer = null;
            }
            if (event.searchTerm !== "") { // get search results
              setSearchParam(event.searchTerm);
              geojsonLayer.visible = true;
              sp = false;
              let searchDataArr = [];
              for (let i = 0; i < event.results.length; i++) {
                if (event.results[i].results.length > 0) {
                  event.results[i].results.map((value, index) => {
                    searchDataArr.push({
                      station_id: value.feature.attributes.station_id,
                      client_station_id: value.feature.attributes.client_station_id,
                      location: value.feature.attributes.station_location,
                      station_type: value.feature.attributes.station_type,
                      latitude: value.feature.attributes.latitude,
                      longitude: value.feature.attributes.longitude,
                      class: '',
                      speed: '',
                      turning: '',
                      pedestrian: '',
                      bicycle: '',
                      volume: '',
                      checked: false
                    })
                  })
                }
              }
              searchDataArr = [...new Map(searchDataArr.map(item => [item.station_id, item])).values()];
              if (searchDataArr.length == 1) {
                setSelectedStationType(searchDataArr[0].station_type);
                setSelectedStation(searchDataArr[0].client_station_id);
                let plat = searchDataArr[0].latitude;
                let plong = searchDataArr[0].longitude;
                view.graphics.removeAll();
                var point = new Point(plong, plat);
                var pointSymbol = {
                  type: "simple-marker",
                  style: "circle",
                  color: "#00A75D",
                  size: 20,
                  outline: {
                    color: "#00A75D",
                    width: 0.5
                  }
                }
                // Create a Graphic the Search widget can display
                var graphic = new Graphic({
                  geometry: point, symbol: pointSymbol,
                });
                view.graphics.add(graphic);
                view.goTo(graphic).then(function () {
                  view.zoom = view.zoom + 5;
                });
              }
              setZoomLevel(null);
              setSearchedStation(graphic);
              setSearchResult(searchDataArr);
              searchedList = searchDataArr;
              setSearchChecked(true);
              setMutipleStationId([]);
              /*** Set cookies for search before login ***/
              if(!Cookies.get('payload')) {
                clearCookie('activeSearchFilter');
                clearCookie('activeSearchStation');
                sessionStorage.setItem('activeSearchResult', JSON.stringify(searchDataArr));
                setCookie('activeSearchText', event.searchTerm);
              }
              /******/
            }
          });

          searchWidget.on("search-clear", function (event) {
            view.graphics.removeAll();
            // view.zoom = 14;
            // if(geojsonLayer) {
            //   geojsonLayer.visible = false;
            // }
            setSearchChecked(false);
            sp = true;
          });
        }
        else {

          getSearchWidget.on("suggest-start", function (event) {
            setSelectedStation(null);
            setMapLayer(true);
            geojsonLayer.visible = false;
            setMidblockChecked(false);
            setIntersectionChecked(false);
            setChecked(false);
          })

          getSearchWidget.on("search-start", function (event) {
            setMapLayer(true);
            setMidblockChecked(false);
            setIntersectionChecked(false);
            setChecked(false);
          })

          getSearchWidget.on("search-complete", function (event) {
            if (geolayer) {
              map.remove(geolayer);
              geolayer = null;
            } else if (myGeoLayer) {
              map.remove(myGeoLayer);
            }
            setMutipleStationId([]);
            if (event.searchTerm !== "") {
              setSearchParam(event.searchTerm);
              geojsonLayer.visible = true;
              sp = false;
              let searchDataArr = [];
              for (let i = 0; i < event.results.length; i++) {
                if (event.results[i].results.length > 0) {
                  event.results[i].results.map((value, index) => {
                    searchDataArr.push({
                      station_id: value.feature.attributes.station_id,
                      client_station_id: value.feature.attributes.client_station_id,
                      location: value.feature.attributes.station_location,
                      station_type: value.feature.attributes.station_type,
                      latitude: value.feature.attributes.latitude,
                      longitude: value.feature.attributes.longitude,
                      class: '',
                      speed: '',
                      turning: '',
                      pedestrian: '',
                      bicycle: '',
                      volume: '',
                      checked: false
                    })
                  })
                }
              }
              searchDataArr = [...new Map(searchDataArr.map(item => [item.station_id, item])).values()];
              if (searchDataArr.length == 1) {
                setSelectedStationType(searchDataArr[0].station_type);
                setSelectedStation(searchDataArr[0].client_station_id);
                let plat = searchDataArr[0].latitude;
                let plong = searchDataArr[0].longitude;
                view.graphics.removeAll();
                var point = new Point(plong, plat);
                var pointSymbol = {
                  type: "simple-marker",
                  style: "circle",
                  color: "#00A75D",
                  size: 20,
                  outline: {
                    color: "#00A75D",
                    width: 0.5
                  }
                }
                // Create a Graphic the Search widget can display
                var graphic = new Graphic({
                  geometry: point, symbol: pointSymbol,
                });
                view.graphics.add(graphic);
                view.goTo(graphic).then(function () {
                  view.zoom = view.zoom + 5;
                });
              }
              setSearchResult(searchDataArr);
              searchedList = searchDataArr;
              setSearchChecked(true);
            }
          });

          getSearchWidget.on("search-clear", function (event) {
            view.graphics.removeAll();
            // view.zoom = 14;
            tempGeoLayer.visible = false;
            setSearchChecked(false);
            sp = true;
          });
        }

        let measure = new Measurement({
          view: view,
        });

        if (changeBasemap == false) {
          let stationLayer = await getGeoJsonData();
          if (stationLayer) { //create geoJSON layer for all stations of agency
            const cluster = {
              type: "cluster",
              clusterRadius: "50px",
             /* popupTemplate: {
                content: "This cluster represents {cluster_count} stations."
              },*/
              clusterMinSize: "40px",
              clusterMaxSize: "40px",
              labelingInfo: [{
                deconflictionStrategy: "none",
                labelExpressionInfo: {
                  expression: "Text($feature.cluster_count, '#,###')"
                },
                symbol: {
                  type: "text",
                  color: "#fff",
                  font: {
                    weight: "bold",
                    family: "Noto Sans",
                    size: "18px"
                  }
                },
                labelPlacement: "center-center",
              }]
            }
            const blob = new Blob([JSON.stringify(stationLayer)], { type: "application/json" });
            const dataUrl = URL.createObjectURL(blob);
            geojsonLayer = new GeoJSONLayer({
              url: dataUrl,
              featureReduction: cluster,
              outFields: ["station_id", "client_station_id", "station_location", "station_type", "latitude", "longitude"],
              renderer: {
                type: "simple",
                field: "station_id",
                symbol: {
                  type: "simple-marker",
                  style: "circle",
                  color: "#24618e",
                  size: 14,
                  outline: {
                    color: "#00A75D",
                    width: 0.5
                  }
                },

              }
            });

            view.watch("scale", (scale) => {
              geojsonLayer.featureReduction =
                view.scale > 18000 ? cluster : null;
            });

            if (stationLayer.length !== 0) {
              geojsonLayer.when(function () {
                if (geojsonLayer) {
                  geojsonLayer.visible = true;
                }
              });
            }
            ////////////////////////////////////////
            //create custom source to format address 
            var customSearchSource = new SearchSource({              
              placeholder: "Search",
              name: "Address",
              displayField: "station_location",
              outFields: ["station_id", "client_station_id", "station_location", "station_type", "latitude", "longitude"],
              // Provide a getSuggestions method
              // to provide suggestions to the Search widget
              getDictionary : function(value_to_searc){    
                let regex = new RegExp('/'+(Object.keys(DICTIONARY_TO_SEARCH).toString()).replaceAll(',','|')+'/gi');
                let newValueTosearhc = '';
                (value_to_searc.split(' ')).forEach(function(word){
                  newValueTosearhc += word.replace(regex, function(matched){
                    return DICTIONARY_TO_SEARCH[matched];
                  }) + ' ';
                });            
                
               return newValueTosearhc.trim();               
              },
              generateQuery : function(value_to_searc,value_to_searc_avv){
                var query = '',
                    query_avv = '';
                (value_to_searc.split(' ')).forEach(function(word){
                  query += (query == '') ? "lower(station_location) like '%"+word+"%'" : " AND lower(station_location) like '%"+word+"%'";
                });
                (value_to_searc_avv.split(' ')).forEach(function(word){
                  query_avv += (query_avv == '') ? "lower(station_location) like '%"+word+"%'" : " AND lower(station_location) like '%"+word+"%'";
                });
                
                return '('+query+') OR ('+query_avv+')';
              },
              getSearchQuery : function(value_to_searc,value_to_searc_avv){
                var query = geojsonLayer.createQuery();
                //query.where = "lower(station_location) like '%"+value_to_searc+"%' OR lower(station_location) like '%"+value_to_searc_avv+"%'";                
                query.where = this.generateQuery(value_to_searc,value_to_searc_avv);
                query.outFields = ["station_id", "client_station_id", "station_location", "station_type", "latitude", "longitude"];

                return query;
              },
              getSuggestions: function(params) {                
                var value_to_searc = (params.suggestTerm).toLowerCase(),                
                    value_to_searc_avv = this.getDictionary(value_to_searc),
                    query = this.getSearchQuery(value_to_searc,value_to_searc_avv);                
                return geojsonLayer.queryFeatures(query).then(function(results){
                  return results.features.map(function(feature) {
                    return {
                      key: "station_location",
                      text: feature.attributes.station_location,
                      sourceIndex: params.sourceIndex
                    };
                  });   
                });
              },
              getResults: function(params) {
                var value_to_searc = (params.suggestResult.text).toLowerCase(),                
                    value_to_searc_avv = this.getDictionary(value_to_searc),
                    query = this.getSearchQuery(value_to_searc,value_to_searc_avv);
                
                return geojsonLayer.queryFeatures(query).then(function(results){                  
                  return results.features.map(function(feature) {                    
                    // Create a Graphic the Search widget can display
                    var graphic = new Graphic({
                      geometry: new Point({
                        x: feature.geometry.x,
                        y: feature.geometry.y
                      }),
                      attributes: feature.attributes
                    });                   
                    // Return a Search Result
                    return {
                      //extent: buffer.extent,
                      feature: graphic,
                      name: feature.attributes.station_location
                    };                  
                  });
                });
              }
            });
            ////////////////////////////////////////////////
            ////////////////////////////////////////////////
            let search = getSearchWidget ? getSearchWidget : searchWidget;
            search.sources = [
              {
                layer: geojsonLayer,
                searchFields: ["station_location"],
                displayField: "station_location",
                exactMatch: false,
                outFields: ["station_id", "client_station_id", "station_location", "station_type", "latitude", "longitude"],
                name: "Station Location",
                placeholder: "Search"
              },
              {
                layer: geojsonLayer,
                searchFields: ["client_station_id"],
                displayField: "client_station_id",
                exactMatch: false,
                outFields: ["station_id", "client_station_id", "station_location", "station_type", "latitude", "longitude"],
                name: "Station Id",
                placeholder: "Search"
              },
              {
                layer: geojsonLayer,
                searchFields: ["display_name"],
                displayField: "display_name",
                exactMatch: false,
                outFields: ["station_id", "client_station_id", "station_location", "station_type", "latitude", "longitude"],
                name: "Display Name",
                placeholder: "Search"
              },
              {
                layer: geojsonLayer,
                searchFields: ["description"],
                displayField: "description",
                exactMatch: false,
                outFields: ["station_id", "client_station_id", "station_location", "station_type", "latitude", "longitude"],
                name: "Description",
                placeholder: "Search"
              },
              {
                layer: geojsonLayer,
                searchFields: ["all_approach"],
                displayField: "station_location",
                exactMatch: false,
                outFields: ["station_id", "client_station_id", "station_location", "station_type", "latitude", "longitude"]
                ,
                name: "Road Name",
                placeholder: "Search"
              },              
              customSearchSource
            ]
            setLoadSource(false);
            searchWidget.container = searchRef.current;
            setTempGeoLayer(geojsonLayer);
            // layers flag validation

            if(layersFlag === 'true'){
              getExternalLayers();
            }              
            else{

              //map.add(geojsonLayer);
            } 
              
          }
        }
        else {
          if ((searchChecked && zoomLevel == null) || geojsonLayer.visible == true) {        
            view.graphics.add(searchedStation);
          } else {
            importRemoveLocation(basemapView);
          }
        }
       
        view.popup = {
         
          dockEnabled: true,
          dockOptions: {
            breakpoint: false,
              buttonEnabled: false,
              position: "bottom-left"
          }
        };
         view.when(function () {
          featureLayer.when(function () {
            let vp = new Viewpoint({
              targetGeometry: featureLayer.fullExtent
            });
            homeButton.viewpoint = vp;
            view.extent = tempView ? tempView.extent : featureLayer.fullExtent;
          });
          map.add(featureLayer); // adds feature layer to map view
           
          if (geojsonLayer) {
            if (searchChecked || true) {
              if(layersFlag === 'true'){
              }              
              else{
                map.add(geojsonLayer);
                polygonValidation();
              } 
            }
          }
        });

        /****/
        // this funcionality is to keep the filter params after login
        if(Cookies.get('payload') && Cookies.get('activeSearchFilter') && Cookies.get('activeSearchFilter') !== '') {
          let filterparams = JSON.parse(Cookies.get('activeSearchFilter'));
          // filter stations layer based on tht filter set before login
          showStationsByFilter(filterparams, map);
          clearCookie('activeSearchFilter');
        }
        // open stations details panel and highlight point based on the cookie set before log in
        if(Cookies.get('payload') && Cookies.get('activeSearchStation') && Cookies.get('activeSearchStation') !== '') {
          getStationDetail(JSON.parse(Cookies.get('activeSearchStation')));
        }
        // this funcionlaity is to keep the search params after login
        if(Cookies.get('payload') && Cookies.get('activeSearchText') && Cookies.get('activeSearchText') !== '') {
          let searchTerm = Cookies.get('activeSearchText');
          let searchRes = sessionStorage.getItem('activeSearchResult') ? JSON.parse(sessionStorage.getItem('activeSearchResult')) : [];
          setChecked(false);
          if (geolayer) {
            map.remove(geolayer);
            geolayer = null;
          }
          if (searchTerm !== "") { // get search results
            if(searchTerm !== "polygon")
              setSearchParam(searchTerm);
            geojsonLayer.visible = true;
            sp = false;
            let searchDataArr = [];
            for (let i = 0; i < searchRes.length; i++) {
              if (searchRes.length > 0) {
                searchRes.map((value, index) => {
                  searchDataArr.push({
                    station_id: value.station_id,
                    client_station_id: value.client_station_id,
                    location: value.location,
                    station_type: value.station_type,
                    latitude: value.latitude,
                    longitude: value.longitude,
                    class: '',
                    speed: '',
                    turning: '',
                    pedestrian: '',
                    bicycle: '',
                    volume: '',
                    checked: false
                  })
                })
              }
            }
            searchDataArr = [...new Map(searchDataArr.map(item => [item.station_id, item])).values()];
            if (searchDataArr.length == 1) {
              setSelectedStationType(searchDataArr[0].station_type);
              setSelectedStation(searchDataArr[0].client_station_id);
              let plat = searchDataArr[0].latitude;
              let plong = searchDataArr[0].longitude;
              view.graphics.removeAll();
              var point = new Point(plong, plat);
              var pointSymbol = {
                type: "simple-marker",
                style: "circle",
                color: "#00A75D",
                size: 20,
                outline: {
                  color: "#00A75D",
                  width: 0.5
                }
              }
              // Create a Graphic the Search widget can display
              var graphic = new Graphic({
                geometry: point, symbol: pointSymbol,
              });
              view.graphics.add(graphic);
              view.goTo(graphic).then(function () {
                view.zoom = view.zoom + 5;
              });
            }
            setZoomLevel(null);
            setSearchedStation(graphic);
            setSearchResult(searchDataArr);
            searchedList = searchDataArr;
            setSearchChecked(true);
            setMutipleStationId([]);
          }
          clearCookie('activeSearchText');
          sessionStorage.removeItem('activeSearchResult');
        }
        /****/

        view.on('pointer-move', function (evt) {
          evt.stopPropagation();
          var screenPoint = {
            x: evt.x,
            y: evt.y
          };
          
          view.hitTest(screenPoint).then(function (response) {
            try {
              if (response.results[0]) {

                let pointData = response.results[0].graphic.attributes;
                let layer_type=response.results[0].graphic.layer.type;
               
                let pointer_external_flag=false;                
                for (const temp_data in response.results) {
                  if(response.results[temp_data].graphic.layer.layer_type_a && response.results[temp_data].graphic.layer.layer_type_a=="external"){
                    pointer_external_flag=true;

                  }
                  
                 

                }
               
                if (pointData && (pointData.station_id || pointData.clusterId || pointer_external_flag )) {
                  if (polygonToggle === false) 
                    document.getElementById("map_block").style.cursor = "pointer";
                }
                else {
                  if (polygonToggle === true) {
                    document.getElementById("map_block").style.cursor = "crosshair";
                  } else {
                    document.getElementById("map_block").style.cursor = "default";
                  }
                }
                
              }
            } catch (error) {
              console.error(error);
            }
          });
        });
 

        view.on("click", function (evt) {
          if (showFileList == 'none') view.graphics.removeAll();
          if (document.getElementById('popup_template'))  {
            var element = document.getElementById("popup_template");
            element.parentNode.removeChild(element);
          } 

          //evt.stopPropagation();
          var screenPoint = {
            x: evt.x,
            y: evt.y
          };
         
          
         
          view.hitTest(screenPoint).then(function (response) {
            let _geolayer=[]
            _geolayer = response.results.filter((value) => {
              if(value.graphic.layer && value.graphic.layer.title=="GeoJSON"){
                 return value 
              }
            })
            response.results=_geolayer;
            view.popup.watch("selectedFeature", function(graphic) {
                
             
               if (graphic) {
                 var graphicTemplate = graphic.getEffectivePopupTemplate();
                 document.getElementById("map_block").style.cursor = "pointer";
                 let arrayContent =[]
    
                 for (const property in graphic.attributes) {

                   if((typeof property)=="string"){
                     arrayContent.push([property,graphic.attributes[property]])
                   }
                 }

                 
               if(flag){

                
                setPopupTitle(graphicTemplate.title)
                setPopupContent(arrayContent)
              
                setPopuptemplateChecked(true);
                setMidblockChecked(false)
                setIntersectionChecked(false)
                
               }
                 
                
               }
    
          
            });

            flag=true
            if (importDataMapPoint == true) {
              
              try {
                let pointData = response.results[0].graphic.attributes;
                
                let selectedData = response.results[0].graphic.geometry;
                if (pointData && pointData.station_id) {
             
                  let stationId = pointData.station_id;
                  let clientStationId = pointData.client_station_id;
                  let stationLocation = pointData.station_location;
                  let stationStatus = pointData.status;
                  let long = selectedData.longitude;
                  let lat = selectedData.latitude;

                  view.graphics.removeAll();
                  let point = new Point(long, lat);

                  let pointSymbol = {
                    type: "simple-marker",
                    style: "circle",
                    color: "#00A75D",
                    size: 20,
                    outline: {
                      color: "#00A75D",
                      width: 0.5
                    }
                  }
                  let graphic = new Graphic({
                    geometry: point, symbol: pointSymbol,
                  });
                  view.graphics.add(graphic);

                  setUseSationId(stationId, clientStationId, stationLocation, stationStatus, long, lat);
                }
                else if (pointData && pointData.clusterId) {
             

                  let point = new Point({
                    longitude: selectedData.longitude,
                    latitude: selectedData.latitude,
                  });

                  let pointGraphic = new Graphic(point, null);

                  view.goTo(pointGraphic).then(function () {
                    view.zoom = view.zoom + 4;
                  });
                }
                else { }
              }
              catch (error) {
                console.error(error);
              }
            }
            else if (response.results.length && sp == false && response.results[0].graphic.attributes) {
              
              let plat = response.results[0].graphic.attributes.latitude;
              let plong = response.results[0].graphic.attributes.longitude;
              let client_station_id = response.results[0].graphic.attributes.client_station_id;
              let station_type = response.results[0].graphic.attributes.station_type;
              let cluster_id = response.results[0].graphic.attributes.clusterId;
              let selectedData = response.results[0].graphic.geometry;
              let station_id = response.results[0].graphic.attributes.station_id;
              if (cluster_id != null) {
                var esri_goto_option = {
                  animate: true,
                  duration: 200,
                  };
           
                  let point = new Point({
                    latitude: selectedData.latitude,
                    longitude: selectedData.longitude
                  });
                
                view.goTo({
                  target: point,
                
                }, esri_goto_option)          
                .catch(function(error) {
                
                  if (error.name != "AbortError") {
                  console.error('zoom to real location, view goto error', error);
                  }
                
                
                });
                view.zoom=view.zoom+4
                /*let point = new Point({
                  latitude: selectedData.latitude,
                  longitude: selectedData.longitude
                });

                let pointGraphic = new Graphic(point, null);
                view.goTo(pointGraphic).then(function () {
                  view.zoom = view.zoom + 4;
                });*/
              }
              else if (client_station_id && station_type) {
                flag=false
                setPopuptemplateChecked(false);

                let stationExists = searchedList.some(ele => ele.client_station_id === client_station_id);
                if (stationExists == true) {
                  setMidblockChecked(false);
                  setIntersectionChecked(false);
                  setSelectedStation(client_station_id);
                  setSelectedStationType(station_type);
                } else {
                  getStationDetail(station_id);
                }
                view.graphics.removeAll();
                var point = new Point(plong, plat);

                var pointSymbol = {
                  type: "simple-marker",
                  style: "circle",
                  color: "#00A75D",
                  size: 20,
                  outline: {
                    color: "#00A75D",
                    width: 0.5
                  }
                }
                // Create a Graphic the Search widget can display
                var graphic = new Graphic({
                  geometry: point,
                  symbol: pointSymbol,
                });
                setSearchedStation(graphic);
                view.graphics.add(graphic);
              }
            }
            else {
              if (response.results[0] && response.results[0].graphic && response.results[0].graphic.attributes) {
               

                let my_station_id = response.results[0].graphic.attributes.station_id;
                let cluster_id = response.results[0].graphic.attributes.clusterId;
                let selectedData = response.results[0].graphic.geometry;

               
                if (cluster_id != null) {
                  
                  var esri_goto_option = {
                    animate: true,
                    duration: 200,
                    };
             
                  let point = new Point({
                    longitude: selectedData.longitude,
                    latitude: selectedData.latitude,
                  });
                  
                  view.goTo({
                    target: point,
                  
                  }, esri_goto_option)          
                  .catch(function(error) {
                  
                    if (error.name != "AbortError") {
                    console.error('zoom to real location, view goto error', error);
                    }
                  
                  
                  });
                  view.zoom=view.zoom+4
                 

                  setMidblockChecked(false);
                  setIntersectionChecked(false);
                  view.graphics.removeAll();
                }
                else if (my_station_id && my_station_id != "") {
             
                  flag=false
                  setPopuptemplateChecked(false);
                  if(!Cookies.get('payload')) {
                    setCookie('activeSearchStation', my_station_id);
                  }

                  let pointSymbol = {
                    type: "simple-marker",
                    style: "circle",
                    color: "#00b15e",
                    size: 20,
                    outline: {
                      color: "#3676bc",
                      width: 0.5
                    }
                  };

                  let point = new Point({
                    longitude: selectedData.longitude,
                    latitude: selectedData.latitude,
                  });

                  let pointGraphic = new Graphic(point, pointSymbol);
                  setSearchedStation(pointGraphic);
                  view.graphics.add(pointGraphic);
                  setMyView(view);

                  try {
                    axios({
                      method: 'get',
                      url: API_URL + API_PATH.getStationDetail + my_station_id,
                    })
                      .then(async function (response) {

                        if (response.data.data.station_type_name === "Midblock") {
                          setPanelStationData(response.data.data)
                          setMidblockChecked(true);
                          setIntersectionChecked(false);
                        }
                        else if (response.data.data.station_type_name === "Intersection") {
                          setPanelStationData(response.data.data)
                          setIntersectionChecked(true);
                          setMidblockChecked(false);
                          
                        }
                        else { }
                      })
                      .catch(function (error) {
                        console.log(error);
                      })
                  } catch (error) {
                    console.error(error);
                  }
                }
                else { }
              }
            };
          })
        });
        setHome(homeButton)
        setZoom(zoom)
        setLocate(locate)
        setMeasurement(measure)

        return () => {
          if (view) {
            view.container = null;
          }
        };
      })
  }
  //This method is use for mapview and handle all map event .... end

  //This method is use for call geoJsonData to show station  by using geoJsonLayer .... Start
  const getGeoJsonData = async () => {
    try {
      let headers = Cookies.get('payload')
        ? {
          'agencyid': sessionStorage.getItem('agency_id'),
          'payload': Cookies.get('payload'),
        }
        : {
          'agencyid': sessionStorage.getItem('agency_id'),
        }
      //this code is create Geojson marker
      return axios({
        method: 'get',
        url: API_URL + API_PATH.stationListGeo,
        headers: headers,
      }).then(function (response) {
        if (response && response.status && response.status == '200') {
          let myGeoJsonLayerData = response.data.data;
          setGeoLayerData(myGeoJsonLayerData);
          return myGeoJsonLayerData;
        }
      })
    } catch (error) {
      console.error(error);
    }
  }
  //This method is use for call geoJsonData to show station  by using geoJsonLayer .... end

  const handleSearchResults = () => {
    setSearchChecked((prev) => !prev);
    searchedList = [];
    tempView.graphics.removeAll();
    tempGeoLayer.visible = false;
    if (geolayer) {
      mapView.remove(geolayer);
      geolayer = null;
    }
    setSearchChecked(false);
    setSearchParam('');
    if (getSearchWidget) getSearchWidget.clear();
    sp = true;
    geojsonLayer.visible = true;
    if(Cookies.get('polygonExtent') || (Cookies.get('activeSearchText')  && Cookies.get('activeSearchText') === 'polygon')) {
      clearCookie('polygonExtent');
      clearCookie('activeSearchText');
    }
    
    clearFilterStations();
  };

  const highlightStation = (latitude, longitude, client_station_id, station_type, tmpView=null) => {
    setZoomLevel(null);
    if (selectedStation !== client_station_id) {
      loadModules(["esri/geometry/Point", "esri/Graphic"], { css: true })
        .then(async ([Point, Graphic]) => {
          setSelectedStation(client_station_id);
          setSelectedStationType(station_type);
          let plat = latitude;
          let plong = longitude;
          if(tmpView) tmpView.graphics.removeAll(); else tempView.graphics.removeAll();

          var point = new Point(plong, plat);
          var pointSymbol = {
            type: "simple-marker",
            style: "circle",
            color: "#00A75D",
            size: 20,
            outline: {
              color: "#00A75D",
              width: 0.5
            }
          }
          // Create a Graphic the Search widget can display
          var graphic = new Graphic({
            geometry: point, symbol: pointSymbol,
          });
          setSearchedStation(graphic);
          if(tmpView) {
            tmpView.zoom = 14;
            tmpView.goTo(graphic).then(function () {           
              tmpView.zoom = tmpView.zoom + 5;
            });
            tmpView.graphics.add(graphic);
          } else {
            tempView.zoom = 14;
            tempView.goTo(graphic).then(function () {           
              tempView.zoom = tempView.zoom + 5;
            });
            tempView.graphics.add(graphic);
          }
        })
    }
  }

  //This method is use for get station details for check the station type and open station penel .... start
  const getStationDetail = (station_id) => {
    if(!Cookies.get('payload')) {
      setCookie('activeSearchStation', station_id);
    }
    try {
      axios({
        method: 'get',
        url: API_URL + API_PATH.getStationDetail + station_id,
      })
        .then(async function (response) {
          let tmpStation = response.data.data;
          if(Cookies.get('payload') && Cookies.get('activeSearchStation')) {
            highlightStation(tmpStation.latitude, tmpStation.longitude, tmpStation.client_station_id, tmpStation.station_type, view);
            clearCookie('activeSearchStation');
          }
          if (response.data.data.station_type_name === "Midblock") {
            setPanelStationData(response.data.data)
            setMidblockChecked(true);
            setIntersectionChecked(false);
          }
          else if (response.data.data.station_type_name === "Intersection") {
            setPanelStationData(response.data.data)
            setIntersectionChecked(true);
            setMidblockChecked(false);
          }
          else { }
        })
        .catch(function (error) {
          console.log(error);
        })
    } catch (error) {
      console.error(error);
    }
  }
  //This method is use for get station details for check the station type and open station penel .... end

  const searchPanel = () => {
    setSearchChecked(true);
  }

  //This method call after clicked show all sation button to show all station .... start
  const ShowAllStations = () => {
    setSearchedStation(null);
    setMidblockChecked(false);
    setIntersectionChecked(false);
    if (geoLayerData && geoLayerData.length == 0) {
      setErrPopUp(true);
      setGeoJSONNF(true);
    } else {
      geolayer = null;
      geojsonLayer.visible = true;
      importDataMapPoint= false;
      setDetails([]);
      setMapLocation([]);
      setShowFileList('none');
      setLoaderShow('block');
      setShowimportData('none');
      removeMatchLocation();
      getSearchWidget.disabled = false;
      removeAllMapLocations();
      handlePopUp();      
    }
  }
  //This method call after clicked show all sation button to show all station .... end

  //This method is use for show the available on filter ... start
  const showStationsByFilter = (filters, map_view=null) => {
    importDataMapPoint= false;
    setDetails([]);
    setMapLocation([]);
    setShowFileList('none');
    setLoaderShow('block');
    setShowimportData('none');
    setGeoJSONNF(false);
    setMidblockChecked(false);
    setIntersectionChecked(false);
    if(!map_view) {
      removeMatchLocation();
      getSearchWidget.disabled = false;
      try {
        tempView.graphics.removeAll();
      } catch (e) {
        console.log("error : ", e)
      }
    }
    let apiData = {
      startdate: filters.startDate,
      enddate: filters.endDate,
      selected_type: filters.selected_type
    }
    for (let [key, value] of Object.entries(filters)) {
      if (value == true) {
        apiData[key] = value;
      }
    }
    loadModules(["esri/layers/GeoJSONLayer", "esri/layers/FeatureLayer", "esri/Viewpoint"], { css: true })
      .then(([GeoJSONLayer, FeatureLayer, Viewpoint]) => {

        let headers = Cookies.get('payload')
          ? {
            'agencyid': sessionStorage.getItem('agency_id'),
            'payload': Cookies.get('payload'),
          }
          : {
            'agencyid': sessionStorage.getItem('agency_id'),
          }

        axios({
          method: 'post',
          data: apiData,
          headers: headers,
          url: API_URL + API_PATH.filterStation,
        })
          .then(async function (response) {
            if (response.data.data.features == null || response == undefined) {
              setErrPopUp(true);
              setGeoJSONNF(true);
              setLoaderOff(false);
            } else {
              setSearchChecked(false);
              sp = true;
              setErrPopUp(false);
              setGeoJSONNF(false);
              // setLoaderOff(false);
              loaderFunction()
              const GeoJSONBlob = new Blob([JSON.stringify(response.data.data)], { type: "application/json" });
              const GeoJSONUrl = URL.createObjectURL(GeoJSONBlob);

              const renderer = {
                type: "simple",
                field: "station_id",
                symbol: {
                  type: "simple-marker",
                  style: "circle",
                  color: "#24618e",
                  size: 14,
                  outline: {
                    color: "#00A75D",
                    width: 0.5
                  }
                }
              }

              const cluster = {
                type: "cluster",
                clusterRadius: "50px",
               /* popupTemplate: {
                  content: "This cluster represents {cluster_count} stations."
                },*/
                clusterMinSize: "40px",
                clusterMaxSize: "40px",
                labelingInfo: [{
                  deconflictionStrategy: "none",
                  labelExpressionInfo: {
                    expression: "Text($feature.cluster_count, '#,###')"
                  },
                  symbol: {
                    type: "text",
                    color: "#fff",
                    font: {
                      weight: "bold",
                      family: "Noto Sans",
                      size: "18px"
                    }
                  },
                  labelPlacement: "center-center",
                }]
              }
              geojsonLayer.visible = false;
              if(!map_view)
                removeAllMapLocations();
              geolayer = new GeoJSONLayer({
                url: GeoJSONUrl,
                featureReduction: cluster,
                renderer: renderer
              });
              myGeoLayer = geolayer;
              // homeEvent();
              if(map_view) {
                map_view.add(myGeoLayer);
                map_view.zoom = mapView.zoom + 4;
              } else {
                mapView.add(myGeoLayer);
                mapView.zoom = mapView.zoom + 4;
              }
              // await setCookie('geolayer', geolayer);
              handlePopUp();
              setLoaderOff(false);
            }
          })
          .catch(function (error) {
            console.log("error : ", error)
            setErrPopUp(true);
            setGeoJSONNF(true);
            setLoaderOff(true);
          })
      })
  }
  //This method is use for show the available on filter ... end

  const ShowErrPopUP = () => {
    setErrPopUp(false)
  };

  const handlePopUp = () => {
    setMapLayer(!getMapLayer);
    setLoaderOff(false);
    setGeoJSONNF(false);
    setChecked((prev) => !prev);
  };

  const handleMidBlock = () => {
    let pointView = myView;
   
    setSearchedStation(null);
    setMidblockChecked((prev) => !prev);
    try {
      if (pointView) {
        pointView.graphics.removeAll();
      }
    } catch (e) {
      console.log("error : ", e)
    }
  };

  const handlePopBlock = () => {
    let pointView = myView;
  
    
    setPopuptemplateChecked((prev) => !prev);
    try {
      if (pointView) {
        pointView.graphics.removeAll();
      }
    } catch (e) {
      console.log("error : ", e)
    }
  };

  const handleIntersection = () => {
    let pointView = myView;
    setSearchedStation(null);
    
    setIntersectionChecked((prev) => !prev);
    try {
      if (pointView) {
        pointView.graphics.removeAll();
      }
    } catch (e) {
      console.log("error : ", e)
    }
  };

  const handleClickAway = () => {
    setChecked(false);
    if (getMapLayer == false) {
      setMapLayer(!getMapLayer);
    }
  }

  const exportpopUp = () => {
    if (exportChecked == 'none') {
      setExportChecked('block');
    }
    else {
      setExportChecked('none');
      //setMutipleStationId([]);
    }
  }
  const callback = (basemap) => { // callback method to set basemap
    changeBasemap = true;
    setbasemap(basemap);
    callMap(basemap);
  }

  const contextValue = {
    data: basemap,
    handleClick: callback
  }

  const locationEvent = () => { // event to locate current position
    locate.locate();
    locate.on("locate", function (locateEvent) {
    })
  }

  const homeEvent = () => { // event to go at initial view
    home.go();
    home.on("go", function (event) {
    });
    setMidblockChecked(false);
    setIntersectionChecked(false);
    basemapView.graphics.removeAll()
  }

  const ZoomInEvent = () => { // event to zoom in map
    zoom.zoomIn();

  }

  const zoomOutEvent = () => { // event to zoom out map
    zoom.zoomOut();
  }

  /* This function is for handle import data pop up */
  const getStationId = () => {
    try {
      axios({
        method: 'get',
        url: API_URL + API_PATH.getAllStationsByAgencyAPI,
        headers: {
          'agencyid': sessionStorage.getItem('agency_id'),
          'payload': Cookies.get('payload'),
        },
      }).then(async function (response) {
        if (response.status && response.status == '200') {
          stationData = response.data;
          stationData = stationData.data;
          for (let i = 0; i < stationData.length; i++) {
            stationIDData.push({ station_id: stationData[i].station_id, stationId: stationData[i].client_station_id });
          }
          setStationDetails([...stationDetails, ...stationIDData]);
        } else {
          console.log("Do Not Get Any Station ID");
        }
      }).catch(async function (error) {
        if (error.response) {
          if (error.response.status && error.response.status == '401') {
            if (Cookies.get('email')) {
              clearCookie('email');
              clearCookie('payload');
              clearCookie('idToken');
              clearCookie('atexpiry');
            }
            history.push('/');
          }
        }
      })
    } catch (error) {
      console.error(error);
    }
  }

  const changeMapView = (tempDeta) => {
    // 
    tempView.graphics.removeAll();
    importRemoveLocation();
    // lazy load the required ArcGIS API for JavaScript modules and CSS
    loadModules(["esri/geometry/Point", "esri/Graphic"], { css: true })
      .then(([Point, Graphic]) => {
        //This Code is used for Marker Point              
        try {
          axios({
            method: 'get',
            url: API_URL + API_PATH.getAllStationsByAgencyAPI,
            headers: {
              'agencyid': sessionStorage.getItem('agency_id'),
              'payload': Cookies.get('payload'),
            },

          }).then(async function (response) {
            if (response.status && response.status == '200') {
              stationData = response.data;
              stationData = stationData.data;
              for (let i = 0; i < stationData.length; i++) {
                if (tempDeta !== '') {
                  tempDeta.map((mpl, index) => {
                    if (stationData[i].client_station_id === mpl.clent_Station_id) {
                      const pointSymbol = {
                        type: "simple-marker",
                        style: "circle",
                        color: "#24618e",
                        size: 14,
                        outline: {
                          color: "#00A75D",
                          width: 0.5
                        }
                      }
                      point = new Point({
                        longitude: stationData[i].longitude,
                        latitude: stationData[i].latitude,
                      });
                      pointGraphic = new Graphic(point, pointSymbol);
                      tempView.graphics.add(pointGraphic);
                    }
                  });
                }
              }
            } else {
              console.log("Do Not Get Any Station ID");
            }
          })
        } catch (error) {
          console.error(error);
        }
      });
  }

  const removeMatchLocation = () => {
    tempView.graphics.removeAll();
  }
 
  //This method is use for call station list for check station is present on not .... start
  const getAllStationList = () => {
    try {
      //this code is used for imported marker
      axios({
        method: 'get',
        url: API_URL + API_PATH.pointStaionList,
        headers: {
          'agencyid': sessionStorage.getItem('agency_id'),
        },
      }).then(async function (response) {
        setAllStationList(response.data.data);
      }).catch(async function (error) {
        if (error.response) {
          if (error.response.status && error.response.status == '401') {
            if (Cookies.get('email')) {
              clearCookie('email');
              clearCookie('payload');
              clearCookie('idToken');
              clearCookie('atexpiry');
            }
            history.push('/');
          }
        }
      })
    } catch (error) {
      console.error(error);
    }
  }
  //This method is use for call station list for check station is present on not .... end


  //This method is use for call all locations/station after clicked on location icon ... start
  const callAllMapLocations = async () => {
    await removeAllMapLocations();
    loadModules(["esri/layers/GeoJSONLayer", "esri/geometry/Point", "esri/Graphic"], { css: true })
      .then(async ([GeoJSONLayer, Point, Graphic]) => {
        try {
          const cluster = {
            type: "cluster",
            clusterRadius: "50px",
          /*  popupTemplate: {
              content: "This cluster represents {cluster_count} stations."
            },*/
            clusterMinSize: "40px",
            clusterMaxSize: "40px",
            labelingInfo: [{
              deconflictionStrategy: "none",
              labelExpressionInfo: {
                expression: "Text($feature.cluster_count, '#,###')"
              },
              symbol: {
                type: "text",
                color: "#000",
                font: {
                  weight: "bold",
                  family: "Noto Sans",
                  size: "18px"
                }
              },
              labelPlacement: "center-center",
            }]
          }
          const blob = new Blob([JSON.stringify(geoLayerData)], { type: "application/json" });
          const dataUrl = URL.createObjectURL(blob);
          const geojsonLayer = new GeoJSONLayer({
            url: dataUrl,
            featureReduction: cluster,
            outFields: ["station_id", "client_station_id", "station_location", "station_type", "latitude", "longitude", "status"],
            renderer: {
              type: "simple",
              field: "station_id",
              symbol: {
                type: "simple-marker",
                style: "circle",
                color: "#dcdbe3",
                size: 14,
                outline: {
                  color: "#3676bc",
                  width: 0.5
                }
              }
            }
          });
          setGeoLayer(geojsonLayer);
          myGeoLayer = geojsonLayer;
          mapView.add(geojsonLayer);
          await setCookie('geoJsonLayer', geojsonLayer);
        }
        catch (error) {
          console.error(error);
        }
      });
  }
  //This method is use for call all locations/station after clicked on location icon ... end

  const setUseSationId = (stationId, clientStationId, stationLocation, stationStatus, long, lat) => {
    setIdIndex(myIndexValue);
    setShowimportData('none');
    setShowUseStationData('block');
    setFileCountData('none');
    setShowImportButton('none');
    getUseStationDetails(stationId, clientStationId, stationLocation, stationStatus, long, lat);
  }

  const getUseStationDetails = (stationId, clientStationId, stationLocation, stationStatus, long, lat) => {
    try {
      setUseStationId(clientStationId);
      setUseStationLocation(stationLocation);
      setUseStationLat(lat);
      SetUseStationLong(long);
      SetUseStationStatus(stationStatus);
    } catch (error) {
      console.error(error);
    }
  }

  const removeAllMapLocations = async () => {
    let myGeo = Cookies.get('geoJsonLayer');
    mapView.remove(geoLayer);
    mapView.remove(myGeoLayer);
    mapView.remove(myGeo);
    await clearCookie('geoJsonLayer');
  }

  const afterLocationSelect = (tempdata) => {
    tempView.graphics.removeAll();
    // lazy load the required ArcGIS API for JavaScript modules and CSS
    loadModules(["esri/geometry/Point", "esri/Graphic", "esri/symbols/PictureMarkerSymbol", "esri/PopupTemplate"], { css: true })
      .then(([Point, Graphic, PictureMarkerSymbol]) => {
        //This Code is used for Marker Point              
        try {
          for (let i = 0; i < tempdata.length; i++) {
            if (tempdata[i].sationId !== '') {
              if (tempdata[i].file_status == 'success') {
                let items = allStationList;
                let data;
                let long;
                let lat;
                data = items.filter(item => item.client_station_id === tempdata[i].sationId);
                long = data[0].longitude;
                lat = data[0].latitude;
                let pointSymbol = {
                  type: "simple-marker",
                  style: "circle",
                  color: "#24618e",
                  size: 14,
                  outline: {
                    color: "#00A75D",
                    width: 0.5
                  }
                }
                point = new Point({
                  longitude: long,
                  latitude: lat,
                });
                pointGraphic = new Graphic(point, pointSymbol);
                tempView.graphics.add(pointGraphic);
              }
            }
          }
        } catch (error) {
          console.error(error);
        }
      });
  }

  const importRemoveLocation = (basemapView = null) => {
    let view;
    if (basemapView) {
      view = basemapView;
    } else {
      view = tempView;
    }
    view.graphics.removeAll();
    // lazy load the required ArcGIS API for JavaScript modules and CSS
    loadModules(["esri/geometry/Point", "esri/Graphic", "esri/symbols/PictureMarkerSymbol", "esri/PopupTemplate"], { css: true })
      .then(([Point, Graphic, PictureMarkerSymbol]) => {
        //This Code is used for Marker Point              
        try {
          for (let i = 0; i < details.length; i++) {
            if (details[i].sationId !== '') {
              let items = allStationList;
              let data;
              let long;
              let lat;
              data = items.filter(item => item.client_station_id === details[i].sationId);
              long = data[0].longitude;
              lat = data[0].latitude;
              let pointSymbol = {
                type: "simple-marker",
                style: "circle",
                color: "#24618e",
                size: 14,
                outline: {
                  color: "#00A75D",
                  width: 0.5
                }
              }
              point = new Point({
                longitude: long,
                latitude: lat,
              });
              pointGraphic = new Graphic(point, pointSymbol);
              view.graphics.add(pointGraphic);
            }
          }
        } catch (error) {
          console.error(error);
        }
      });
  }

  /* This funtion is call for stored multiple station Id start*/
  const multipleStations = (event, selected_Station, station_type, client_Station_Id, Station_location) => {
    let indexExprot = multipleStationId.findIndex((ele, index) => ele.station_id === selected_Station);
    if (event == true) {
      if (indexExprot === -1) {
        setMutipleStationId([...multipleStationId, { station_id: selected_Station, station_type: station_type, client_Station_Id: client_Station_Id, Station_location: Station_location }]);
      } else {
        let newArr = [...multipleStationId];
        newArr[indexExprot] = {
          station_id: multipleStationId[indexExprot].station_id,
          station_type: multipleStationId[indexExprot].station_type,
          client_Station_Id: multipleStationId[indexExprot].client_Station_Id,
          Station_location: multipleStationId[indexExprot].Station_location,
        };
        setMutipleStationId(newArr);
      }
    }
    else {
      if (indexExprot !== -1) {
        let newArr = multipleStationId;
        newArr.splice(indexExprot, 1);
        setMutipleStationId(newArr);
      }
    }
  }
  /* This funtion is call for stored multiple station Id end*/

  /* This funtion is call for stored single Station station Id start*/
  const singleMidblockStations = (selected_Station, station_type, client_Station_Id, Station_location) => {
    setSingleMidblockStationId([{ station_id: selected_Station, station_type: station_type, client_Station_Id: client_Station_Id, Station_location: Station_location }]);
  }
  /* This funtion is call for stored single station Id end*/

  /* This funtion is call for stored single Station station Id start*/
  const singleIntersectionStations = (selected_Station, station_type, client_Station_Id, Station_location) => {
    setSingleIntersectionStationId([{ station_id: selected_Station, station_type: station_type, client_Station_Id: client_Station_Id, Station_location: Station_location }]);
  }
  /* This funtion is call for stored single station Id end*/

  /* This funtion is call for stored all station Id start*/
  const allStations = (e, station_type, stationsArr) => {
    let tempArray = [];
    if (e.target.checked) {
      if (stationsArr.length > 0) {
        for (let i = 0; i < stationsArr.length; i++) {
          let indexExprot = multipleStationId.findIndex((ele, index) => ele.station_id === stationsArr[i].station_id);
          if (indexExprot === -1) {
            tempArray.push({ station_id: stationsArr[i].station_id, station_type: stationsArr[i].station_type, client_Station_Id: stationsArr[i].client_station_id, Station_location: stationsArr[i].location });
          }
        }
        setMutipleStationId([...multipleStationId, ...tempArray]);
      }
    } else {
      let dataArray = multipleStationId;
      for (let i = 0; i < stationsArr.length; i++) {
        let indexExprot = multipleStationId.findIndex((ele, index) => ele.station_id === stationsArr[i].station_id);
        if (indexExprot !== -1) {
          dataArray.splice(indexExprot, 1);
        }
      }
      setMutipleStationId(dataArray);
    }
    setMutipleStationId([...multipleStationId, ...tempArray]);
  }
  /* This funtion is call for stored multiple station Id end*/

  const clearFilterStations = () => {
    //remove filter from stations layers
    let featureFilter = {
      geometry: null
    };
    if (geojsonLayer.visible && featureLayerView) {
      featureLayerView.effect = {
        filter: featureFilter,
        excludedEffect: "grayscale(100%) opacity(60%)"
      };
    } else if(filterLayerView) {
      filterLayerView.effect = {
        filter: featureFilter,
        excludedEffect: "grayscale(100%) opacity(60%)"
      };
    }
  }

  const clearFilterExternalLayers = () => {
    //remove filter from external layers
    let featureFilter = {
      geometry: null
    };
    // effect to excluded features from external layers
    featurExternalLayerView.forEach(function(extLay){
      if (extLay) {
        extLay.effect = {
          filter: featureFilter,
          excludedEffect: "grayscale(100%) opacity(60%)"
        };
      }
    })
  }

  function selectFeatures(geometry, view) {
    view.graphics.removeAll();

    const query = {
      geometry: geometry,
      outFields: ["*"]
    };

    // filter to highlight the features
    let featureFilter = {
      geometry
    };

    let cc = 0;
    let vis = 0;
    let tmpToExport = [];
    cLayers.forEach(function(clayer){
      if(clayer.visible && clayer.layerName !== "Stations") {
        vis++;
        let layerObj = clayer.layerObj;
        query.returnGeometry = true;
        query.outSpatialReference = {"wkid" : 4326}
        layerObj.queryFeatures(query)
        .then(function(cres){
          cc++;
          let tmp = [];
          cres.features.forEach(function(it){
            if(clayer.layerType === "point"){
                if(it.geometry.latitude)
                  tmp.push({attributes: it.attributes, geometry: [it.geometry.longitude, it.geometry.latitude]});
                else 
                  tmp.push({attributes: it.attributes, geometry: [it.geometry.x, it.geometry.y]});
            } else if(clayer.layerType === "polygon"){
              if(it.geometry.rings)
                tmp.push({attributes: it.attributes, geometry: it.geometry.rings});
            } else if(clayer.layerType === "polyline"){
              if(it.geometry.paths)
                tmp.push({attributes: it.attributes, geometry: it.geometry.paths[0]});
            }
          });
          if(cres.features.length > 0)
            tmpToExport.push({layerName: clayer.layerName, layerType: clayer.layerType, features: tmp});
          if(cc === vis) {
            let sortedLayers = [];
            cLayers.forEach(function(clayer){
              let clayerName = clayer.layerName;
              let filterRes = tmpToExport.filter((layer) => clayerName === layer.layerName);
              if(filterRes.length > 0){
                sortedLayers.push(filterRes[0])
              }
            });
            setExternalLayersToExport(sortedLayers);
          }
        });
      }
    })
    // effect to exclude the features from external layers
    cLayers.forEach(function(ly){
      if(ly.visible && ly.layerName !== "Stations") {
        let obj = ly.layerObj;
        view.whenLayerView(obj).then((lV) => {
          if(lV.layer.layer_type_a === "external"){
            featurExternalLayerView.push(lV);
            lV.effect = {
              filter: featureFilter,
              excludedEffect: "grayscale(100%) opacity(60%)"
            };
          }
        });
      }
    })


    let layer = geojsonLayer.visible == true ? geojsonLayer : geolayer;
    // create a query and set its geometry parameter to the
    // polygon that was drawn on the view
    if (layer) {

      // query graphics from the csv layer view. Geometry set for the query
      // can be polygon for point features and only intersecting geometries are returned
      layer
        .queryFeatures(query)
        .then(function (results) {
          const graphics = results.features;
          // if the grid div is displayed while query results does not
          // return graphics then hide the grid div and show the instructions div
          if (graphics.length > 0) {
            // zoom to the extent of the polygon with factor 2
            view.goTo(geometry.extent.expand(2)).catch(function (error) {
              if (error.name != "AbortError") {
                console.error(error);
              }
            });
            view.zoom = view.zoom + 2;
            sp = false;
            let searchDataArr = [];
            for (let i = 0; i < graphics.length; i++) {
              searchDataArr.push({
                station_id: graphics[i].attributes.station_id,
                client_station_id: graphics[i].attributes.client_station_id,
                location: graphics[i].attributes.station_location,
                station_type: graphics[i].attributes.station_type,
                latitude: graphics[i].attributes.latitude,
                longitude: graphics[i].attributes.longitude,
                class: '',
                speed: '',
                turning: '',
                pedestrian: '',
                bicycle: '',
                volume: '',
                checked: false
              })
            }
            searchDataArr = [...new Map(searchDataArr.map(item => [item.station_id, item])).values()];
            setSearchResult(searchDataArr);
            searchedList = searchDataArr;
            setSearchChecked(true);
            setMutipleStationId([]);
            // set cookie for polygon selection before sign in
            if(!Cookies.get('payload')) {
              clearCookie('activeSearchFilter');
              clearCookie('activeSearchStation');
              setCookie('activeSearchText', 'polygon');
              sessionStorage.setItem('activeSearchResult', JSON.stringify(searchDataArr));
              let obj = {
                xmax: geometry.extent.xmax,
                xmin: geometry.extent.xmin,
                ymax: geometry.extent.ymax,
                ymin: geometry.extent.ymin,
                spatialReference: {
                  wkid: geometry.extent.spatialReference.wkid,
                  latestWkid: geometry.extent.spatialReference.latestWkid
                }
              }
              setCookie('polygonExtent', JSON.stringify(obj));
            }
          }
        })
        .catch();

      // effect to exclude stations from geojsonlayer
      if (geojsonLayer.visible) {
        view.whenLayerView(geojsonLayer).then((layerView) => {
          if(layerView.layer.type === "geojson"){
            featureLayerView = layerView;
            layerView.effect = {
              filter: featureFilter,
              excludedEffect: "grayscale(100%) opacity(60%)"
            };
          }
        });
      } else {
        // effect to exclude stations from geolayer, filter stations
        view.whenLayerView(geolayer).then((layerView) => {
          if(layerView.layer.type === "geojson"){
            filterLayerView = layerView;
            layerView.effect = {
              filter: featureFilter,
              excludedEffect: "grayscale(100%) opacity(60%)"
            };
          }
        });
      }
    }
  }

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  
  return <>
    
    <ImportPanel 
      checkedImport={checkedImport} 
      importStationId={importStationId}
      details={details}
      setDetails={setDetails}
      setLoaderShow={setLoaderShow}
      setImportResponceValue={setImportResponceValue}
      setShowFileList={setShowFileList}
      setShowimportData={setShowimportData}
      stationDetails={stationDetails}
      setMapLocation={setMapLocation}
      mapLocation={mapLocation}
      fileCountData={fileCountData}
      setMidblockChecked={setMidblockChecked}
      setIntersectionChecked={setIntersectionChecked}
      setSearchChecked={setSearchChecked}
      getSearchWidget={getSearchWidget}
      pointView={myView}
      tempView={tempView}
      geojsonLayer={geojsonLayer}
      removeAllMapLocations={removeAllMapLocations}
      importRemoveLocation={importRemoveLocation}
      changeMapView={changeMapView}
    />

    <ImportList 
      showFileList={showFileList}
      setShowFileList={setShowFileList}
      setLoaderShow={setLoaderShow}
      details={details}
      importResponceValue={importResponceValue}
      fileCountData={fileCountData}
      importStationId={importStationId}
      showimportData={showimportData}
      setShowimportData={setShowimportData}
      setImportResponceValue={setImportResponceValue}
      setMapLocation={setMapLocation}
      setDetails={setDetails}
      callAllMapLocations={callAllMapLocations}
      importRemoveLocation={importRemoveLocation}
      setIdIndex={setIdIndex}
      idIndex={idIndex}
      stationDetails={stationDetails}
      useStationId={useStationId}
      setUseStationId={setUseSationId}
      useStationLocation={useStationLocation}
      useStationLat={useStationLat}
      useStationLong={useStationLong}
      useStationStatus={useStationStatus}
      showUseStationData={showUseStationData}
      setShowUseStationData={setShowUseStationData}
      setSearchShowUseStationData={setSearchShowUseStationData}
      showSearchUseStationData={showSearchUseStationData}
      setFileCountData={setFileCountData}
      showImportButton={showImportButton}
      setShowImportButton={setShowImportButton}
      afterLocationSelect={afterLocationSelect}
      loaderShow={loaderShow}
      searchResult={searchResult}
      getSearchWidget={getSearchWidget}
      getStationDetail={getStationDetail}
      tempView={tempView}
      myGeoLayer={myGeoLayer}
      mapView={mapView}
      geojsonLayer={geojsonLayer}
      setSearchChecked={setSearchChecked}
      searchParam={searchParam}
      removeMatchLocation={removeMatchLocation}
      removeAllMapLocations={removeAllMapLocations}
      callLocations={callLocations}
      useThisStationDataStation={useThisStationDataStation}
    />

  {/* External layers component */}
  <ExternalLayers 
    sidebarWidth={sidebarWidth}
    handleShowLayersContainer={handleShowLayersContainer}
    customLayers={customLayers}
    setCustomLayers={setCustomLayers}
    myCustomLayers={myCustomLayers}
    setMyCustomLayers={setMyCustomLayers}
    handleLayerVisibility={handleLayerVisibility}
    handleAddLayer={handleAddLayer}
    handleSaveLayer={handleSaveLayer}
    addingExternalLayer={addingExternalLayer}
    layerName={layerName}
    setLayerName={setLayerName}
    layerUrl={layerUrl}
    setLayerUrl={setLayerUrl}
    handleReorderLayer={handleReorderLayer}
    showExternalLayers={showExternalLayers}
  />
  
  <div className={classes.mainMapContainer} >
    <div data-testid="webmapContainer" className="webmap" id="map_block" ref={mapRef} style={{ height: '100%', width: '100%', position: 'fixed' }} />
    <div id="basemapToggle"></div>
    <Box display='flex' flexDirection="column" className={classes.homeIconList}>
      <div data-testid="homeBtn" className={classes.homeIcon} title="Home">
        <FontAwesomeIcon icon={faHome} onClick={() => homeEvent()} title="Home" />
      </div>
      <div data-testid="locationBtn" className={classes.locationIcon} style={{ height: '40px' }} title="View My Location">
        <LocationSearchingIcon style={{ marginTop: '4px' }}
          onClick={() => locationEvent()} title="View My Location" />
      </div>
      <div data-testid="zoomInBtn" className={classes.zoomIcon} style={{ marginBottom: '-3px' }} title="Zoom In">
        <FontAwesomeIcon icon={faPlus}
          onClick={() => ZoomInEvent()} title="Zoom In" />
      </div>
      <div data-testid="zoomOutBtn" className={classes.inIcon} title="Zoom Out">
        <FontAwesomeIcon icon={faMinus}
          onClick={() => zoomOutEvent()} title="Zoom Out" />
      </div>
    </Box>
    <ClickAwayListener onClickAway={handleClickAway}>
      <div className={classes.popupoverlap}>
        <div className={classes.inputSearch}>
          <div className={classes.layerButton}><Button aria-describedby={id} className={getMapLayer ? classes.showBtn : classes.hideBtn} variant="contained" color="primary" onClick={handlePopUp} title="System Layers">
            <FilterListIcon data-testid="filterBtn" className={classes.btnIcon} />
          </Button></div>
          <div className={classes.textField}>
            {loadSource == false ? <div ref={searchRef} data-testid="searchInput"></div>

              : <div className={classes.searchLoader}><CircularProgress /></div>}
          </div>
          <div className={classes.fieldIcons}>
            <div data-testid="polygonSelectionBtn" className={polygonActive ? classes.hidePolygon : classes.polygon} id="select-by-polygon"
              title="Polygon Tool" ><FontAwesomeIcon icon={faObjectGroup} title="Polygon Tool" /> </div>            
          </div>
        </div>
        <Collapse in={checked} className={classes.homePopBox} style={{position:"inherit",zIndex:"55"}}  >          
          <div className={classes.mainpopup} >
            <Paper elevation={4} className={classes.paper}>
              <MapContext.Provider value={contextValue}>
                <Home
                  callHome={showStationsByFilter}
                  ShowAllStations={ShowAllStations}
                  geojsonNF={geoJSONNF}
                  loaderFunction={loaderFunction}
                  loaderOff={loaderOff}
                  loadSource={loadSource}
                  checked={checked}
                />
              </MapContext.Provider>
            </Paper>
          </div>         
        </Collapse>
        <Collapse in={midblockChecked} className={classes.homePopBox} >
          {
            midblockChecked &&
            <MidBlock
              showExternalLayers={showExternalLayers}
              sidebarWidth={sidebarWidth}
              passMidValue={handleMidBlock}
              stationData={panelStationData}
              searchPanel={searchPanel}
              searchChecked={searchChecked}
              checkExportValue={exportpopUp}
              groupStations={singleMidblockStations}
              setStation={singleMidblockStationId}
            />
          }
        </Collapse>

        <Collapse in={intersectionChecked} className={classes.homePopBox} >
          {
            intersectionChecked &&
            <Intersection
              showExternalLayers={showExternalLayers}
              sidebarWidth={sidebarWidth}
              passIntersectionValue={handleIntersection}
              stationData={panelStationData}
              searchPanel={searchPanel}
              searchChecked={searchChecked}
              checkExportValue={exportpopUp}
              groupStations={singleIntersectionStations}
              setStation={singleIntersectionStationId}
            />
          }
        </Collapse>
        <Collapse in={popuptemplateChecked} className={classes.homePopBox} >
          {
           
            popuptemplateChecked &&
            <PopupTemplate
              showExternalLayers={showExternalLayers}
              sidebarWidth={sidebarWidth}
              passPopValue={handlePopBlock}
              
              title={popupTitle}
              content={popupContent}
              midblockChecked={midblockChecked}
              intersectionChecked={intersectionChecked}
              searchChecked={searchChecked}
             
            />
          }
        </Collapse>
        <Collapse in={searchChecked} className={classes.homePopBox} >
          {
            searchChecked &&
            <SearchResults
              showExternalLayers={showExternalLayers}
              sidebarWidth={sidebarWidth}
              passMidValue={handleSearchResults}
              resultData={searchResult}
              searchParam={searchParam}
              selectedStation={selectedStation}
              highlightStation={highlightStation}
              selectedStationType={selectedStationType}
              getStationDetail={getStationDetail}
              checkExportValue={exportpopUp}
              groupStations={multipleStations}
              setStation={multipleStationId}
              allStations={allStations}
            />
          }
        </Collapse>
      </div>
    </ClickAwayListener>
    {exportChecked == 'block' ?
      <div className={classes.exportDataPanel} style={{ display: exportChecked }}>
        <ExportData checkExportValue={exportpopUp} groupStations={midblockChecked ? singleMidblockStationId : intersectionChecked ? singleIntersectionStationId : multipleStationId} />
      </div>
      : null}
    {
      props.newLogin ?
        <div className={classes.errMsgLogin}>
          <ErrorMessage message={'You\'re signed in and ready to explore'} visible={ShowErrPopUP} show={errPopUp} />
        </div> : null
    }
    {/* External layers button */}
    {
     (!showExternalLayers && layersFlag === 'true') &&
      <div className={classes.layerExternalButton}>
        <Button className={classes.externalLayersBtn} data-testid="externalLayersBtn" variant="contained" color="primary" onClick={handleShowLayersContainer} title="External Layers">
          <LayersIcon  />
        </Button>
      </div>
    }
    {/* Export External Layers modal */}
    {
      externalLayersToExport.length > 0 &&
      <ExportExternalLayers 
        externalLayersToExport={externalLayersToExport}
        setExternalLayersToExport={setExternalLayersToExport}
        clearFilterExternalLayers={clearFilterExternalLayers}
      />
    }
  </div>
  </>
}

export default MapView;
//End MapView component code ...